export default "__VITE_ASSET__BZSeDHvX__"